export default {"src":"/_next/static/media/applepay-logo.9681f641.svg","height":106,"width":166,"blurWidth":0,"blurHeight":0};